import { render } from "./formal_document_template_wizard_view.html?vue&type=template&id=634d05ac&scoped=true&external"
import script from "./formal_document_template_wizard.js?vue&type=script&lang=js&external"
export * from "./formal_document_template_wizard.js?vue&type=script&lang=js&external"

import "./FormalDocumentTemplateWizard.vue?vue&type=style&index=0&id=634d05ac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634d05ac"]])

export default __exports__